// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1mt1C","icon":"style_icon__26bL9"};